import { Tab } from '@mui/material';
import type { TabProps as MUITabProps } from '@mui/material';
import { Link } from 'react-router-dom';

interface LocalPageTabProps {
  /**
   * @prop {string} - The tab id, is used as part of test id's
   */
  id: string;

  /**
   * @prop {boolean} - Is the tab active
   */
  isActive: boolean;

  /**
   * @prop {string} - The tab path
   */
  path: string;
}

export type PageTabProps = LocalPageTabProps & Omit<MUITabProps, 'disableRipple'>;

// Create a CustomTab component that uses the Link component
export const PageTab = (props: PageTabProps) => {
  const { path, isActive, ...rest } = props;
  return <Tab component={Link} to={path} {...rest} disableRipple />;
};
